import React, {useCallback, useEffect, useState} from 'react';
import {ScanBarcodeAction, useScanBarcodeReducer} from '../hooks/ScanBarcode';

import BarcodeScanIcon from '@buncha/components/core/icon/BarcodeScanIcon';
import Header from '@buncha/components/composites/Header/Header';
import {HomeScreens} from '@buncha/home/navigation/types';
import KeyboardAvoidLayout from '@buncha/components/composites/keyboardAvoidLayout';
import {Modules} from '@buncha/utils/types';
import ScanBarcodeHeader from '../components/ScanBarcode/ScanBarcodeHeader';
import {ScanBarcodeParams} from '../types/scanBarcode';
import {ScanBarcodesContext} from '../context/ScanBarcode';
import ScannerComponent from '../components/ScanBarcode/ScannerComponent';
import ScreenHeader from '@buncha/common/components/screenHeader';
import {StyleSheet} from 'react-native';
import UnableToScanBarcodeSheet from '../components/ScanBarcode/unableToScanBarcodeSheet';
import {useGetLocale} from '@buncha/localization/hooks';
import {useRoute} from '@react-navigation/native';

const ScanBarcode = () => {
  const [unableToScan, setUnableToScan] = useState(false);

  const [state, dispatch] = useScanBarcodeReducer();
  const {title} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};

  const barcodeCount = state?.barcodeCount;
  const route = useRoute();
  const params: ScanBarcodeParams | undefined = route?.params;
  const runId = params?.runId;

  const toggleBottomSheet = useCallback(() => {
    setUnableToScan(!unableToScan);
  }, [unableToScan]);

  useEffect(() => {
    if (params && params?.totalScanned)
      dispatch(
        ScanBarcodeAction.setBarcodesCount({
          total: params?.totalScanned || 0,
          scanned: params.scanned || 0,
        }),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return (
    <KeyboardAvoidLayout>
      <ScanBarcodesContext.Provider value={{state, dispatch}}>
        <Header
          showDefaultLeftHeader
          hideBottomSafeArea
          headerRightComponent={
            <BarcodeScanIcon style={styles.barcodeIcon} viewBox="0 -1 35 35" />
          }>
          <ScreenHeader
            title={title?.scannedBarcodes
              ?.replace('{barcodeCountScanned}', barcodeCount?.scanned || 0)
              ?.replace('{barcodeCountTotal}', barcodeCount?.total)}
          />
          <ScanBarcodeHeader
            unableToScanBottomSheetHandele={toggleBottomSheet}
          />
          <ScannerComponent
            orderIds={params?.orderIds ?? []}
            orderInfo={params?.orderInfo || []}
          />
          <UnableToScanBarcodeSheet
            open={unableToScan}
            onClose={toggleBottomSheet}
            orderIds={params?.orderIds || []}
            runId={runId}
            orderInfo={params?.orderInfo || []}
          />
        </Header>
      </ScanBarcodesContext.Provider>
    </KeyboardAvoidLayout>
  );
};

export default React.memo(ScanBarcode);

const styles = StyleSheet.create({
  barcodeIcon: {
    marginRight: 10,
  },
});
